import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { CONTROLLERS, ENDPOINTS } from 'src/app/constants';

@Injectable({
  providedIn: 'root'
})
export class PayTypeService {
  private api: string = CONTROLLERS.TENANTS.PAYTYPE;
  constructor(private apiService: ApiService) { }

  getPayTypeDropdown(
    customerId: number,
    practiceId: number
  ) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAY_TYPE.PAY_TYPE_DROPDOWN}`,
      {
        practiceId,
        customerId
      }
    );
  }

  getPayTypeDropdownByPaymentMethod(
    paymentMethodMappingId: number,
    customerId: number,
    practiceId: number
  ) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PAY_TYPE.PAY_TYPE_DROPDOWN_BY_PAYMENT_METHOD}`,
      {
        paymentMethodMappingId,
        practiceId,
        customerId
      }
    );
  }
}
